/**
 * Pure rules on the answer of `registre/apsolution_login` (APScan login dialogs).
 *
 * The backend writes the user-facing sentence in `message` (Apscan_login_rules); older answers
 * only carried APScan's own `access_token.response.description` ("Login error").
 */

export const APSCAN_LOGIN_ERROR_TITLE = 'APScan login failed';

const FALLBACK_MESSAGE =
  'Could not log in to APScan. Check the email and password of your APScan account '
  + '(not your ArturPro credentials) and try again.';

/** True when the answer is a successful APScan login. */
export function isApscanLoginSuccess(data: any): boolean {
  return data?.status !== 'error' && data?.access_token?.response?.status === 0;
}

/** Sentence to show when the login failed, with the request reference when there is one. */
export function apscanLoginErrorMessage(data: any): string {
  const candidates = [data?.message, data?.access_token?.response?.description];
  const message = candidates
    .map((value) => (typeof value === 'string' ? value.trim() : ''))
    .find((value) => value !== '' && value.toLowerCase() !== 'login error');
  const reference = typeof data?.request_id === 'string' && data.request_id.trim() !== ''
    ? ` (Reference: ${data.request_id.trim()})`
    : '';
  return (message || FALLBACK_MESSAGE) + reference;
}
